"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.TooltipContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _nicbaseTranslation = require("nicbase-translation");

var _arrival = _interopRequireDefault(require("./arrival"));

var _departure = _interopRequireDefault(require("./departure"));

var _stop = _interopRequireDefault(require("./stop"));

require("./tooltip-content.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var mapStateToProps = function mapStateToProps(state) {
  return {
    timeZone: state.user.timezone
  };
};

exports.mapStateToProps = mapStateToProps;

var TooltipContent = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TooltipContent, _React$PureComponent);

  var _super = _createSuper(TooltipContent);

  function TooltipContent(props) {
    var _this;

    _classCallCheck(this, TooltipContent);

    _this = _super.call(this, props);
    _this.renderArrival = _this.renderArrival.bind(_assertThisInitialized(_this));
    _this.renderDeparture = _this.renderDeparture.bind(_assertThisInitialized(_this));
    _this.renderStop = _this.renderStop.bind(_assertThisInitialized(_this));
    _this.renderEmptyInfo = _this.renderEmptyInfo.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TooltipContent, [{
    key: "renderArrival",
    value: function renderArrival() {
      var _this$props = this.props,
          waypoint = _this$props.waypoint,
          timeZone = _this$props.timeZone;
      var scheduledTimeOfArrival = waypoint.scheduledTimeOfArrival,
          estimatedTimeOfArrival = waypoint.estimatedTimeOfArrival,
          realTimeOfArrival = waypoint.realTimeOfArrival,
          earlyTolerance = waypoint.earlyTolerance,
          lateTolerance = waypoint.lateTolerance;

      if (scheduledTimeOfArrival || estimatedTimeOfArrival || realTimeOfArrival) {
        return /*#__PURE__*/_react["default"].createElement(_arrival["default"], {
          scheduledTimeOfArrival: scheduledTimeOfArrival,
          realTimeOfArrival: realTimeOfArrival,
          estimatedTimeOfArrival: estimatedTimeOfArrival,
          earlyTolerance: earlyTolerance,
          lateTolerance: lateTolerance,
          timeZone: timeZone
        });
      }

      return null;
    }
  }, {
    key: "renderDeparture",
    value: function renderDeparture() {
      var _this$props2 = this.props,
          waypoint = _this$props2.waypoint,
          timeZone = _this$props2.timeZone;
      var scheduledTimeOfArrival = waypoint.scheduledTimeOfArrival,
          realTimeOfArrival = waypoint.realTimeOfArrival,
          estimatedTimeOfArrival = waypoint.estimatedTimeOfArrival,
          realTimeOfDeparture = waypoint.realTimeOfDeparture,
          plannedStopDuration = waypoint.plannedStopDuration,
          plannedStartTime = waypoint.plannedStartTime; // calculate departure values based on arrival and stop

      var scheduledTimeOfDeparture;
      var estimatedTimeOfDeparture;

      if (plannedStartTime) {
        scheduledTimeOfDeparture = new Date(plannedStartTime);
      }

      if (plannedStopDuration) {
        if (scheduledTimeOfArrival) {
          scheduledTimeOfDeparture = new Date(new Date(scheduledTimeOfArrival).getTime() + plannedStopDuration * 60000);
        }

        if (realTimeOfArrival || estimatedTimeOfArrival) {
          estimatedTimeOfDeparture = new Date(new Date(realTimeOfArrival || estimatedTimeOfArrival).getTime() + plannedStopDuration * 60000);
        }
      }

      if (scheduledTimeOfDeparture || realTimeOfDeparture || estimatedTimeOfDeparture) {
        return /*#__PURE__*/_react["default"].createElement(_departure["default"], {
          scheduledTimeOfDeparture: scheduledTimeOfDeparture,
          realTimeOfDeparture: realTimeOfDeparture,
          estimatedTimeOfDeparture: estimatedTimeOfDeparture,
          timeZone: timeZone
        });
      }

      return null;
    }
  }, {
    key: "renderStop",
    value: function renderStop() {
      var waypoint = this.props.waypoint;
      var realTimeOfArrival = waypoint.realTimeOfArrival,
          realTimeOfDeparture = waypoint.realTimeOfDeparture,
          plannedStopDuration = waypoint.plannedStopDuration; // calculate stop duration

      var realStopDuration;

      if (realTimeOfArrival && realTimeOfDeparture) {
        var departureDate = new Date(realTimeOfDeparture);
        departureDate.setSeconds(0);
        departureDate.setMilliseconds(0);
        var arrivalDate = new Date(realTimeOfArrival);
        arrivalDate.setSeconds(0);
        arrivalDate.setMilliseconds(0);
        realStopDuration = (departureDate.getTime() - arrivalDate.getTime()) / 60000;
      }

      if (plannedStopDuration || realStopDuration) {
        return /*#__PURE__*/_react["default"].createElement(_stop["default"], {
          scheduledStopDuration: plannedStopDuration,
          realStopDuration: realStopDuration
        });
      }

      return null;
    }
  }, {
    key: "renderEmptyInfo",
    value: function renderEmptyInfo() {
      var waypoint = this.props.waypoint;
      var realTimeOfArrival = waypoint.realTimeOfArrival,
          realTimeOfDeparture = waypoint.realTimeOfDeparture,
          plannedStopDuration = waypoint.plannedStopDuration,
          scheduledTimeOfArrival = waypoint.scheduledTimeOfArrival,
          estimatedTimeOfArrival = waypoint.estimatedTimeOfArrival,
          plannedStartTime = waypoint.plannedStartTime;

      if (!(scheduledTimeOfArrival || realTimeOfArrival || estimatedTimeOfArrival || realTimeOfDeparture || plannedStopDuration || plannedStartTime)) {
        return /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "widgets.tourBoard.infoBlock.noInformationAvailable",
          tagName: "span"
        });
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var waypoint = this.props.waypoint;
      var name = waypoint.name,
          type = waypoint.type;
      var icon = (0, _mapping.getPoiCategoryIcon)(type);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "waypoint-tooltip"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "block"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "block-title"
      }, /*#__PURE__*/_react["default"].createElement(icon), /*#__PURE__*/_react["default"].createElement("span", {
        className: "name"
      }, name))), this.renderArrival(), this.renderDeparture(), this.renderStop(), this.renderEmptyInfo());
    }
  }]);

  return TooltipContent;
}(_react["default"].PureComponent);

exports.TooltipContent = TooltipContent;
TooltipContent.propTypes = {
  waypoint: _propTypes["default"].shape({
    scheduledTimeOfArrival: _propTypes["default"].string,
    estimatedTimeOfArrival: _propTypes["default"].string,
    realTimeOfArrival: _propTypes["default"].string,
    earlyTolerance: _propTypes["default"].number,
    lateTolerance: _propTypes["default"].number,
    realTimeOfDeparture: _propTypes["default"].string,
    plannedStopDuration: _propTypes["default"].number,
    plannedStartTime: _propTypes["default"].string,
    name: _propTypes["default"].string,
    type: _propTypes["default"].string
  }).isRequired,
  timeZone: _propTypes["default"].string
};
TooltipContent.defaultProps = {
  timeZone: 'Europe/Berlin'
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(TooltipContent);

exports["default"] = _default;